import { Tier } from '../models/pricing.model';

// The gateway expects VOICE for CLI tiers and applies its own dates when they are left out.
export function tiersForSave(tiers: Tier[]): Tier[] {
  return tiers.map(tier => {
    const payload: Tier = { ...tier, serviceType: tier.serviceType === 'CLI' ? 'VOICE' : tier.serviceType };
    if (!payload.visibleFrom) {
      delete payload.visibleFrom;
    }
    if (!payload.visibleUntil) {
      delete payload.visibleUntil;
    }
    return payload;
  });
}
